import { PageLayout } from '@/shared/components/PageLayout'
import { content } from '@/lib/content'

export default function AboutPage() {
  return (
    <PageLayout
      title={content.about.seo.title}
      description={content.about.seo.description}
    >
      <div className="py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold text-center mb-12">{content.about.heading}</h1>

          <div className="max-w-4xl mx-auto space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6">{content.about.origins.heading}</h2>
              <div className="text-lg text-gray-700 space-y-4">
                {content.about.origins.paragraphs.map((paragraph, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
                ))}
              </div>
            </section>

            <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <img
                  src={content.about.mainHall.image}
                  alt="Main Hall"
                  className="rounded-lg shadow-lg mb-4"
                />
                <h3 className="text-2xl font-bold mb-3">{content.about.mainHall.heading}</h3>
                <p className="text-gray-700">
                  {content.about.mainHall.description}
                </p>
              </div>

              <div>
                <img
                  src={content.about.lowerHall.image}
                  alt="Lower Hall"
                  className="rounded-lg shadow-lg mb-4"
                />
                <h3 className="text-2xl font-bold mb-3">{content.about.lowerHall.heading}</h3>
                <p className="text-gray-700" dangerouslySetInnerHTML={{ __html: content.about.lowerHall.description }} />
              </div>
            </section>

            <section>
              <div className="bg-gray-50 rounded-lg p-8">
                <img
                  src={content.about.amenities.image}
                  alt="Amenities"
                  className="rounded-lg shadow-lg mb-6"
                />
                <h3 className="text-2xl font-bold mb-4">{content.about.amenities.heading}</h3>
                {content.about.amenities.paragraphs.map((paragraph, index) => (
                  <p key={index} className={`text-gray-700 ${index > 0 ? 'mt-4' : ''}`} dangerouslySetInnerHTML={{ __html: paragraph }} />
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
